import {Component, Input} from "@angular/core";
import {AppAlertGqlModel} from "./app-alert.gql-model";

@Component({
  selector: "app-alert",
  templateUrl: "./app-alert.template.pug",
})
export class AppAlertComponent {
  @Input()
  public alert: AppAlertGqlModel;
}
